import { Route } from '@angular/router';
import { AuthorizedLayoutComponent } from './core/layouts/authorized-layout.component';
import { UnauthorizedLayoutComponent } from './core/layouts/unauthorized-layout.component';
import { authGuard } from './core/guards/auth.guard';
import { noAuthGuard } from './core/guards/no-auth.guard';
import { oauthCallbackGuard } from './core/guards/oauth-callback.guard';
import { reportsResolver } from './features/reports/reports.component';

export const appRoutes: Route[] = [
  {
    path: 'oauth-callback',
    canActivate: [oauthCallbackGuard],
    children: [],
  },
  {
    path: 'oauth-callback-web',
    canActivate: [oauthCallbackGuard],
    children: [],
  },
  {
    path: '',
    component: AuthorizedLayoutComponent,
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    children: [
      { path: '', redirectTo: 'accounts', pathMatch: 'full' },
      {
        data: { preload: true },
        path: 'accounts',
        loadComponent: () => import('./features/accounts/accounts.component').then((m) => m.AccountsComponent),
      },
      {
        path: 'expenses',
        data: { preload: true },
        loadComponent: () => import('./features/expenses/expenses.component').then((m) => m.ExpensesComponent),
      },
      {
        path: 'planned-expenses',
        loadComponent: () =>
          import('./features/planned-expenses/planned-expenses.component').then((m) => m.PlannedExpensesComponent),
      },
      {
        path: 'planned-incomes',
        loadComponent: () =>
          import('./features/planned-incomes/planned-incomes.component').then((m) => m.PlannedIncomesComponent),
      },
      {
        path: 'incomes',
        data: { preload: true },
        loadComponent: () => import('./features/incomes/incomes.component').then((m) => m.IncomesComponent),
      },
      {
        path: 'received-credits',
        loadComponent: () =>
          import('./features/received-credits/received-credits.component').then((m) => m.ReceivedCreditsComponent),
      },
      {
        path: 'received-credits/:id/payments',
        loadComponent: () =>
          import('./features/received-credits/payments/received-credit-payments.component').then(
            (m) => m.ReceivedCreditPaymentsComponent,
          ),
      },
      {
        path: 'issued-loans',
        loadComponent: () =>
          import('./features/issued-loans/issued-loans.component').then((m) => m.IssuedLoansComponent),
      },
      {
        path: 'issued-loans/:id/payments',
        loadComponent: () =>
          import('./features/issued-loans/payments/issued-loan-payments.component').then(
            (m) => m.IssuedLoanPaymentsComponent,
          ),
      },
      {
        path: 'currencies',
        loadComponent: () => import('./features/currencies/currencies.component').then((m) => m.CurrenciesComponent),
      },
      {
        path: 'categories/currencies',
        loadComponent: () =>
          import('./features/currencies/currency-manage.component').then((m) => m.CurrencyManageComponent),
      },
      {
        path: 'categories',
        loadComponent: () =>
          import('./features/categories/categories-hub.component').then((m) => m.CategoriesHubComponent),
      },
      {
        path: 'categories/incomes',
        loadComponent: () =>
          import('./features/categories/category-incomes.component').then((m) => m.CategoryIncomesComponent),
      },
      {
        path: 'categories/expenses',
        loadComponent: () =>
          import('./features/categories/category-expenses.component').then((m) => m.CategoryExpensesComponent),
      },
      {
        path: 'categories/debtors',
        loadComponent: () => import('./features/dictionaries/debtor-list.component').then((m) => m.DebtorListComponent),
      },
      {
        path: 'categories/creditors',
        loadComponent: () =>
          import('./features/dictionaries/creditor-list.component').then((m) => m.CreditorListComponent),
      },
      {
        path: 'categories/tags',
        loadComponent: () => import('./features/dictionaries/tag-list.component').then((m) => m.TagListComponent),
      },
      {
        path: 'settings',
        loadComponent: () => import('./features/settings/settings.component').then((m) => m.SettingsComponent),
      },
      {
        path: 'settings/logs',
        loadComponent: () =>
          import('./features/log-console/logs-console.component').then((m) => m.LogsConsoleComponent),
      },
      {
        path: 'backups',
        loadComponent: () => import('./features/backup/backup.component').then((m) => m.BackupComponent),
      },
      {
        path: 'bank-imports',
        loadComponent: () =>
          import('./features/bank-imports/bank-imports.component').then((m) => m.BankImportsComponent),
      },
      {
        path: 'reports',
        loadComponent: () => import('./features/reports/reports.component').then((m) => m.ReportsComponent),
        resolve: { 0: reportsResolver },
      },
    ],
  },
  {
    path: '',
    component: UnauthorizedLayoutComponent,
    canActivate: [noAuthGuard],
    children: [
      {
        path: 'login',
        loadComponent: () => import('./features/login/login.component').then((m) => m.LoginComponent),
      },
      {
        path: 'register',
        loadComponent: () =>
          import('./features/registration/registration-wizard.component').then((m) => m.RegistrationWizardComponent),
      },
    ],
  },
  {
    path: 'error',
    loadComponent: () => import('./features/error/error.component').then((m) => m.ErrorComponent),
  },
  { path: '**', redirectTo: 'login' },
];
